import { Navigate, Outlet } from "react-router-dom";

const AnonymousRoutes = ({ isAuth, isAdmin }) => {
    if (!isAuth) {
        return <Outlet />;
    }

    if (isAdmin) {
        return <Navigate to="/admin/orders" />;
    }

    if (isAuth) {
        return <Navigate to="/" />;
    }

};

export default AnonymousRoutes;
